// import React, { useEffect, useState } from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import { useLocation } from "react-router-dom";
// import * as Yup from "yup";
// import {
//     Button,
//     Grid,
//     TextField,
//     FormControl,
//     Select,
//     MenuItem,
//     FormHelperText
// } from "@mui/material";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
// import { Country, State, City } from "country-state-city";

// const EditCustomer = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const customerDetails = location.state?.customerDetails;

//     const [alert, setAlert] = React.useState(false);
//     const [alertContent, setAlertContent] = React.useState("");
//     const [alertType, setAlertType] = React.useState("");

//     const handleAlert = () => setAlert(false);

//     const [countries] = useState(Country.getAllCountries());
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [selectedCountry, setSelectedCountry] = useState(null);
//     const [selectedState, setSelectedState] = useState(null);

//     const initialValues = {
//         name: customerDetails?.name || "",
//         industry: customerDetails?.industry || "",
//         country: customerDetails?.country || "",
//         state: customerDetails?.state || "",
//         city: customerDetails?.city || "",
//         headCount: customerDetails?.head_count || "",
//         revenue: customerDetails?.revenue || "",
//         primaryContactNumber: customerDetails?.primary_contact_number || "",
//         primaryContactEmail: customerDetails?.primary_contact_email || ""
//     };

//     const validationSchema = Yup.object().shape({
//         name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
//         industry: Yup.string().required("Industry is required"),
//         country: Yup.string().required("Country is required"),
//         state: Yup.string().required("State is required"),
//         city: Yup.string().required("City is required"),
//         headCount: Yup.number().required("Head count is required").positive("Must be positive"),
//         revenue: Yup.number().required("Revenue is required").positive("Must be positive"),
//         primaryContactNumber: Yup.string().required("Primary contact number is required"),
//         primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
//     });

//     // Preselect country/state from existing values
//     useEffect(() => {
//         if (customerDetails?.country) {
//             const c = countries.find((x) => x.name === customerDetails.country) || null;
//             setSelectedCountry(c);
//             if (c) {
//                 const sList = State.getStatesOfCountry(c.isoCode);
//                 setStates(sList);
//             }
//         }
//     }, [customerDetails, countries]);

//     useEffect(() => {
//         if (customerDetails?.state && selectedCountry) {
//             const s = State.getStatesOfCountry(selectedCountry.isoCode).find(
//                 (x) => x.name === customerDetails.state
//             ) || null;
//             setSelectedState(s);
//             if (s) {
//                 const cList = City.getCitiesOfState(s.countryCode, s.isoCode);
//                 setCities(cList);
//             }
//         }
//     }, [customerDetails, selectedCountry]);

//     useEffect(() => {
//         if (selectedCountry && !customerDetails?.country) {
//             setStates(State.getStatesOfCountry(selectedCountry.isoCode));
//             setCities([]);
//         }
//     }, [selectedCountry, customerDetails]);

//     useEffect(() => {
//         if (selectedState && !customerDetails?.state) {
//             setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
//         }
//     }, [selectedState, customerDetails]);

//     const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//     const config = { headers: { Authorization: `Bearer ${token}` } };

//     const onSubmit = async (values, { setSubmitting }) => {
//         try {
//             const payload = {
//                 ...values,
//                 location: `${values.city}, ${values.state}, ${values.country}`
//             };
//             const res = await API.put(`/api/customer/${customerDetails.customer_id}`, payload, config);
//             setAlertContent(res?.data?.message || "Customer updated successfully");
//             setAlertType("success");
//             setAlert(true);
//             setTimeout(() => {
//                 navigate("/customers");
//             }, 1500);
//         } catch (error) {
//             setAlertContent(error?.response?.data?.message || "Failed to update customer");
//             setAlertType("error");
//             setAlert(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const navigateToPreviousPage = () => navigate(-1);

//     return (
//         <div style={{ marginTop: "20px" }}>
//             <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//                 Back
//             </Button>
//             <div
//                 style={{
//                     border: "1px solid #989898",
//                     borderRadius: "10px",
//                     padding: "15px"
//                 }}
//             >
//                 <div
//                     style={{
//                         fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                         fontSize: "20px",
//                         fontWeight: "500",
//                         letterSpacing: "1",
//                         textAlign: "left"
//                     }}
//                 >
//                     <span>Edit Customer</span>
//                 </div>
//                 <div style={{ display: "grid", marginTop: "15px" }}>
//                     <Formik
//                         initialValues={initialValues}
//                         validationSchema={validationSchema}
//                         onSubmit={onSubmit}
//                         enableReinitialize
//                     >
//                         {(formik) => (
//                             <Form noValidate>
//                                 <Grid container spacing={2}>
//                                     {/* Name */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Customer Name</span>
//                                         <TextField
//                                             name="name"
//                                             label="Customer Name"
//                                             fullWidth
//                                             value={formik.values.name}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.name && formik.errors.name && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.name}
//                                             </div>
//                                         )}
//                                     </Grid>
//                                     {/* Primary Contact Email */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: '16px' }}>Contact Email</span>
//                                         <TextField
//                                             name="primaryContactEmail"
//                                             type="email"
//                                             fullWidth
//                                             value={formik.values.primaryContactEmail}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.primaryContactEmail && formik.errors.primaryContactEmail && (
//                                             <div style={{ color: 'red', marginTop: '4px', fontSize: '14px' }}>
//                                                 {formik.errors.primaryContactEmail}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Primary Contact Number */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: '16px' }}>Contact Number</span>
//                                         <TextField
//                                             name="primaryContactNumber"
//                                             fullWidth
//                                             value={formik.values.primaryContactNumber}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.primaryContactNumber && formik.errors.primaryContactNumber && (
//                                             <div style={{ color: 'red', marginTop: '4px', fontSize: '14px' }}>
//                                                 {formik.errors.primaryContactNumber}
//                                             </div>
//                                         )}
//                                     </Grid>
//                                     {/* Industry */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Industry</span>
//                                         <TextField
//                                             name="industry"
//                                             label="Industry"
//                                             fullWidth
//                                             value={formik.values.industry}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.industry && formik.errors.industry && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.industry}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Country */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Country</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.country && formik.errors.country)}
//                                         >
//                                             <Select
//                                                 name="country"
//                                                 value={formik.values.country}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const countryName = e.target.value;
//                                                     formik.setFieldValue("country", countryName);
//                                                     const sel = countries.find((c) => c.name === countryName) || null;
//                                                     setSelectedCountry(sel);
//                                                     setSelectedState(null);
//                                                     formik.setFieldValue("state", "");
//                                                     formik.setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select Country</em>
//                                                 </MenuItem>
//                                                 {countries.map((c) => (
//                                                     <MenuItem key={c.isoCode} value={c.name}>
//                                                         {c.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.country && formik.errors.country}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* State */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>State</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.state && formik.errors.state)}
//                                         >
//                                             <Select
//                                                 name="state"
//                                                 value={formik.values.state}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const stateName = e.target.value;
//                                                     formik.setFieldValue("state", stateName);
//                                                     const sel = states.find((s) => s.name === stateName) || null;
//                                                     setSelectedState(sel);
//                                                     formik.setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select State</em>
//                                                 </MenuItem>
//                                                 {states.map((s) => (
//                                                     <MenuItem key={s.isoCode} value={s.name}>
//                                                         {s.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.state && formik.errors.state}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* City */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>City</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.city && formik.errors.city)}
//                                         >
//                                             <Select
//                                                 name="city"
//                                                 value={formik.values.city}
//                                                 displayEmpty
//                                                 onChange={formik.handleChange}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select City</em>
//                                                 </MenuItem>
//                                                 {cities.map((ct) => (
//                                                     <MenuItem key={ct.name} value={ct.name}>
//                                                         {ct.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.city && formik.errors.city}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* Head Count */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Head Count</span>
//                                         <TextField
//                                             name="headCount"
//                                             type="number"
//                                             label="Head Count"
//                                             fullWidth
//                                             value={formik.values.headCount}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.headCount && formik.errors.headCount && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.headCount}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Revenue */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Revenue</span>
//                                         <TextField
//                                             name="revenue"
//                                             type="number"
//                                             label="Annual Revenue"
//                                             fullWidth
//                                             value={formik.values.revenue}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.revenue && formik.errors.revenue && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.revenue}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Update button */}
//                                     <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 marginTop: "20px"
//                                             }}
//                                         >
//                                             <Button
//                                                 variant="contained"
//                                                 type="submit"
//                                                 disabled={formik.isSubmitting}
//                                                 style={{
//                                                     background: "#2777AA",
//                                                     fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                                                     fontSize: "16px",
//                                                     fontWeight: "500",
//                                                     letterSpacing: "1"
//                                                 }}
//                                             >
//                                                 Update
//                                             </Button>
//                                         </div>
//                                     </Grid>
//                                 </Grid>
//                                 <Notification
//                                     message={alertContent}
//                                     open={alert}
//                                     severity={alertType}
//                                     onClose={handleAlert}
//                                 />
//                             </Form>
//                         )}
//                     </Formik>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EditCustomer;


// src/pages/Customers/EditCustomer.js
import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import {
    Button, Grid, TextField, FormControl, Select, MenuItem, FormHelperText,
    Divider, Typography, Collapse, IconButton, Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Notification } from "../../utils/Notification";
import API from "../../utils/Axios.utils";
import { Country, State, City } from "country-state-city";

const EditCustomer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const customerDetails = location.state?.customerDetails; // passed from listing page

    const [alert, setAlert] = React.useState(false);
    const [alertContent, setAlertContent] = React.useState("");
    const [alertType, setAlertType] = React.useState("");
    const [contacts, setContacts] = useState([]); // local state for contacts
    const handleAlert = () => setAlert(false);

    const [showContactSection, setShowContactSection] = useState(true);

    // Country / State / City
    const [countries] = useState(Country.getAllCountries());
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);

    const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
    const config = { headers: { Authorization: `Bearer ${token}` } };

    const fetchContacts = async () => {
        if (!customerDetails?.customer_id) return;
        try {
            const res = await API.get(`/api/customer/CustomersContacts/${customerDetails.customer_id}`, config);
            const activeContacts = (res?.data?.contacts || [])
                .filter(c => c.is_deleted === 'N')
                .map(c => ({
                    contact_id: c.contact_id,
                    name: c.name || "",
                    email: c.email || "",
                    phone: c.phone || "",
                }));
            setContacts(activeContacts);
        } catch (error) {
            console.error("Failed to fetch contacts on edit:", error);
        }
    };

    useEffect(() => {
        fetchContacts();
    }, [customerDetails?.customer_id]);

    // Dropdown options (same as AddCustomer)
    const industryOptions = [
        { label: "IT Services & Consulting", value: "IT_Services_&_Consulting" },
        { label: "Healthcare", value: "Healthcare" },
        { label: "Manufacturing", value: "Manufacturing" },
        { label: "Recruitment & staffing agency", value: "Recruitment_&_staffing_agency" },
        { label: "IT Product & services", value: "IT_Product_&_services" },
        { label: "Banking & finance", value: "Banking_&_finance" }
    ];

    const headCountOptions = [
        { label: "0-50", value: "0-50" },
        { label: "50-200", value: "50-200" },
        { label: "200-500", value: "200-500" },
        { label: "500-1000", value: "500-1000" },
        { label: "1000-5000", value: "1000-5000" },
        { label: "5000-10000", value: "5000-10000" },
        { label: "10000-100000", value: "10000-100000" }
    ];

    // Initial values from existing customer
    const initialValues = {
        name: customerDetails?.name || "",
        industry: customerDetails?.industry || "",
        country: customerDetails?.country || "",
        state: customerDetails?.state || "",
        city: customerDetails?.city || "",
        headCount: customerDetails?.head_count || "",
        revenue: customerDetails?.revenue || "",
        primaryContactNumber: customerDetails?.primary_contact_number || "",
        primaryContactEmail: customerDetails?.primary_contact_email || "",
        contactPersons: contacts,
    };

    // Validation (same as AddCustomer)
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
        industry: Yup.string().required("Industry is required"),
        country: Yup.string().required("Country is required"),
        state: Yup.string().required("State is required"),
        city: Yup.string().required("City is required"),
        primaryContactNumber: Yup.string().required("Primary contact number is required"),
        primaryContactEmail: Yup.string()
            .required("Primary contact email is required")
            .email("Invalid email format"),
        headCount: Yup.string().optional(),
        revenue: Yup.number().optional(),
        contactPersons: Yup.array()
            .of(
                Yup.object().shape({
                    name: Yup.string().optional().min(2, "Minimum 2 characters"),
                    email: Yup.string().optional().email("Invalid email format"),
                    phone: Yup.string().optional().min(10, "Minimum 10 digits"),
                })
            ),
    });

    // Initialize location selectors from existing customer
    useEffect(() => {
        if (customerDetails?.country) {
            const c = countries.find((x) => x.name === customerDetails.country) || null;
            setSelectedCountry(c);
            if (c) {
                const sList = State.getStatesOfCountry(c.isoCode);
                setStates(sList);
            }
        }
    }, [customerDetails, countries]);

    useEffect(() => {
        if (customerDetails?.state && selectedCountry) {
            const s =
                State.getStatesOfCountry(selectedCountry.isoCode).find(
                    (x) => x.name === customerDetails.state
                ) || null;
            setSelectedState(s);
            if (s) {
                const cList = City.getCitiesOfState(s.countryCode, s.isoCode);
                setCities(cList);
            }
        }
    }, [customerDetails, selectedCountry]);

    // React to manual country/state changes (same as AddCustomer)
    useEffect(() => {
        if (selectedCountry && !customerDetails?.country) {
            setStates(State.getStatesOfCountry(selectedCountry.isoCode));
            setCities([]);
        }
    }, [selectedCountry, customerDetails]);

    useEffect(() => {
        if (selectedState && !customerDetails?.state) {
            setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
        }
    }, [selectedState, customerDetails]);

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const validContactPersons = values.contactPersons.filter(
                (person) =>
                    (person.name && person.name.trim() !== "") ||
                    (person.email && person.email.trim() !== "") ||
                    (person.phone && person.phone.trim() !== "")
            );

            const payload = {
                name: values.name,
                industry: values.industry,
                location: `${values.city}, ${values.state}, ${values.country}`,
                head_count: values.headCount,
                revenue: values.revenue,
                primary_contact_number: values.primaryContactNumber,
                primary_contact_email: values.primaryContactEmail,
                role: "customer",
                contact_persons: validContactPersons,
            };

            const res = await API.put(
                `/api/customer/${customerDetails.customer_id}`,
                payload,
                config
            );

            setAlertContent(
                res?.data?.message ||
                `Customer and ${validContactPersons.length} contact person(s) updated successfully!`
            );
            setAlertType("success");
            setAlert(true);
            setTimeout(() => navigate("/customers"), 1500);
        } catch (error) {
            setAlertContent(
                error?.response?.data?.message || "Failed to update customer"
            );
            setAlertType("error");
            setAlert(true);
        } finally {
            setSubmitting(false);
        }
    };

    const navigateToPreviousPage = () => navigate(-1);

    return (
        <div style={{ marginTop: "20px" }}>
            <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
                Back
            </Button>
            <div
                style={{
                    border: "1px solid #989898",
                    borderRadius: "10px",
                    padding: "15px",
                }}
            >
                <div
                    style={{
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        fontSize: "20px",
                        fontWeight: "500",
                        letterSpacing: "1",
                        textAlign: "left",
                    }}
                >
                    <span>Edit Customer</span>
                </div>

                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        isSubmitting,
                        setFieldValue,
                    }) => (
                        <Form noValidate>
                            <Grid container spacing={2}>
                                {/* CUSTOMER FIELDS */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        Customer Name <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <TextField
                                        name="name"
                                        fullWidth
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        size="small"
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                    />
                                </Grid>

                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        Industry <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={Boolean(touched.industry && errors.industry)}
                                    >
                                        <Select
                                            name="industry"
                                            value={values.industry}
                                            displayEmpty
                                            onChange={(e) =>
                                                setFieldValue("industry", e.target.value)
                                            }
                                            onBlur={handleBlur}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Industry
                                            </MenuItem>
                                            {industryOptions.map((industry, index) => (
                                                <MenuItem key={index} value={industry.value}>
                                                    {industry.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>
                                            {touched.industry && errors.industry}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* Country */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        Country <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={Boolean(touched.country && errors.country)}
                                    >
                                        <Select
                                            name="country"
                                            value={values.country}
                                            displayEmpty
                                            onChange={(e) => {
                                                const countryName = e.target.value;
                                                setFieldValue("country", countryName);
                                                const sel =
                                                    countries.find((c) => c.name === countryName) ||
                                                    null;
                                                setSelectedCountry(sel);
                                                setSelectedState(null);
                                                setFieldValue("state", "");
                                                setFieldValue("city", "");
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Country
                                            </MenuItem>
                                            {countries.map((c) => (
                                                <MenuItem key={c.isoCode} value={c.name}>
                                                    {c.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>
                                            {touched.country && errors.country}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* State */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        State <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={Boolean(touched.state && errors.state)}
                                    >
                                        <Select
                                            name="state"
                                            value={values.state}
                                            displayEmpty
                                            onChange={(e) => {
                                                const stateName = e.target.value;
                                                setFieldValue("state", stateName);
                                                const sel =
                                                    states.find((s) => s.name === stateName) || null;
                                                setSelectedState(sel);
                                                setFieldValue("city", "");
                                                if (sel) {
                                                    setCities(
                                                        City.getCitiesOfState(
                                                            sel.countryCode,
                                                            sel.isoCode
                                                        )
                                                    );
                                                }
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select State
                                            </MenuItem>
                                            {states.map((s) => (
                                                <MenuItem key={s.isoCode} value={s.name}>
                                                    {s.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>
                                            {touched.state && errors.state}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* City */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        City <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        error={Boolean(touched.city && errors.city)}
                                    >
                                        <Select
                                            name="city"
                                            value={values.city}
                                            displayEmpty
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="" disabled>
                                                Select City
                                            </MenuItem>
                                            {cities.map((ct) => (
                                                <MenuItem key={ct.name} value={ct.name}>
                                                    {ct.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>
                                            {touched.city && errors.city}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* Head Count */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Head Count</span>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name="headCount"
                                            value={values.headCount}
                                            displayEmpty
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Head Count Range
                                            </MenuItem>
                                            {headCountOptions.map((range, index) => (
                                                <MenuItem key={index} value={range.value}>
                                                    {range.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Revenue */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Revenue</span>
                                    <TextField
                                        name="revenue"
                                        type="number"
                                        fullWidth
                                        value={values.revenue}
                                        onChange={handleChange}
                                        size="small"
                                    />
                                </Grid>

                                {/* Primary Email */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        Primary Email <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <TextField
                                        name="primaryContactEmail"
                                        type="email"
                                        fullWidth
                                        value={values.primaryContactEmail}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        size="small"
                                        error={
                                            touched.primaryContactEmail &&
                                            Boolean(errors.primaryContactEmail)
                                        }
                                        helperText={
                                            touched.primaryContactEmail &&
                                            errors.primaryContactEmail
                                        }
                                    />
                                </Grid>

                                {/* Primary Phone */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>
                                        Primary Phone <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <TextField
                                        name="primaryContactNumber"
                                        fullWidth
                                        value={values.primaryContactNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        size="small"
                                        error={
                                            touched.primaryContactNumber &&
                                            Boolean(errors.primaryContactNumber)
                                        }
                                        helperText={
                                            touched.primaryContactNumber &&
                                            errors.primaryContactNumber
                                        }
                                    />
                                </Grid>

                                {/* CONTACT PERSONS SECTION */}
                                <Grid item xl={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            mb: 1,
                                        }}
                                        onClick={() => setShowContactSection(!showContactSection)}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ flexGrow: 1, color: "#000000ff" }}
                                        >
                                            Contact Persons
                                        </Typography>
                                        <IconButton size="small">
                                            {showContactSection ? (
                                                <ExpandLessIcon />
                                            ) : (
                                                <ExpandMoreIcon />
                                            )}
                                        </IconButton>
                                    </Box>

                                    {typeof errors.contactPersons === "string" && (
                                        <FormHelperText sx={{ color: "red", ml: 1, mb: 1 }}>
                                            {errors.contactPersons}
                                        </FormHelperText>
                                    )}

                                    <Collapse in={showContactSection}>
                                        <Divider sx={{ mb: 2 }} />
                                        <FieldArray name="contactPersons">
                                            {({ push, remove }) => (
                                                <div>
                                                    {values.contactPersons.map((contact, index) => (
                                                        <Box key={index} sx={{ mb: 2, p: 2 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    mb: 1,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{ fontWeight: "bold", color: "#1976d2" }}
                                                                >
                                                                    Contact Person {index + 1}
                                                                </Typography>
                                                                {values.contactPersons.length > 1 && (
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => remove(index)}
                                                                        color="error"
                                                                    >
                                                                        <DeleteOutlineIcon />
                                                                    </IconButton>
                                                                )}
                                                            </Box>

                                                            <Grid container spacing={2}>
                                                                <Grid
                                                                    item
                                                                    xl={4}
                                                                    lg={4}
                                                                    md={6}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <span style={{ fontSize: "16px" }}>
                                                                        Name
                                                                    </span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.name`}
                                                                        fullWidth
                                                                        value={contact.name}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(
                                                                            touched.contactPersons?.[index]?.name &&
                                                                            errors.contactPersons?.[index]?.name
                                                                        )}
                                                                        helperText={
                                                                            touched.contactPersons?.[index]?.name &&
                                                                            errors.contactPersons?.[index]?.name
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xl={4}
                                                                    lg={4}
                                                                    md={6}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <span style={{ fontSize: "16px" }}>
                                                                        Email
                                                                    </span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.email`}
                                                                        type="email"
                                                                        fullWidth
                                                                        value={contact.email}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(
                                                                            touched.contactPersons?.[index]?.email &&
                                                                            errors.contactPersons?.[index]?.email
                                                                        )}
                                                                        helperText={
                                                                            touched.contactPersons?.[index]?.email &&
                                                                            errors.contactPersons?.[index]?.email
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xl={4}
                                                                    lg={4}
                                                                    md={6}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <span style={{ fontSize: "16px" }}>
                                                                        Phone
                                                                    </span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.phone`}
                                                                        fullWidth
                                                                        value={contact.phone}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(
                                                                            touched.contactPersons?.[index]?.phone &&
                                                                            errors.contactPersons?.[index]?.phone
                                                                        )}
                                                                        helperText={
                                                                            touched.contactPersons?.[index]?.phone &&
                                                                            errors.contactPersons?.[index]?.phone
                                                                        }
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    ))}

                                                    <Button
                                                        type="button"
                                                        startIcon={<AddCircleOutlineIcon />}
                                                        onClick={() =>
                                                            push({ name: "", email: "", phone: "" })
                                                        }
                                                        sx={{ mt: 1 }}
                                                    >
                                                        Add Another Contact Person
                                                    </Button>
                                                </div>
                                            )}
                                        </FieldArray>
                                    </Collapse>
                                </Grid>

                                {/* Submit */}
                                <Grid item xl={12}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginTop: "20px",
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            disabled={isSubmitting}
                                            style={{
                                                background: "#2777AA",
                                                fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                letterSpacing: "1",
                                            }}
                                        >
                                            Update
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>

                            <Notification
                                message={alertContent}
                                open={alert}
                                severity={alertType}
                                onClose={handleAlert}
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default EditCustomer;
